import { prefetchPage as prefetchLegacyPage } from 'pricing-pages-ui/routes/loadablePages';
import { PublicContentHubPage } from '../pages/loadablePages';
import { getProductGroupBySlug } from '../utils/getProductGroupBySlug';
const STANDALONE_LOADABLES = {
  content: PublicContentHubPage
};
export function prefetchPublicPage(navItem) {
  if (getProductGroupBySlug(navItem)) {
    const loadable = STANDALONE_LOADABLES[navItem];
    if (loadable) {
      void loadable.preload();
    }
    return;
  }
  prefetchLegacyPage(navItem);
}